/*
 * Tenue — quantity-input.js
 * Quantity field with plus and minus buttons.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     <quantity-input>
     ------------------------------------------------------------------------ */
  if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        if (!this.input) return;
        this.querySelectorAll('button[name]').forEach((button) =>
          button.addEventListener('click', (event) => this.onButtonClick(event))
        );
        this.input.addEventListener('change', () => this.updateButtons());
        this.updateButtons();
      }

      onButtonClick(event) {
        event.preventDefault();
        const previous = this.input.value;
        if (event.currentTarget.name === 'plus') {
          this.input.stepUp();
        } else {
          this.input.stepDown();
        }
        if (previous !== this.input.value) {
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      updateButtons() {
        const value = parseInt(this.input.value, 10) || 0;
        const min = this.input.min === '' ? null : parseInt(this.input.min, 10);
        const max = this.input.max === '' ? null : parseInt(this.input.max, 10);
        const minus = this.querySelector('button[name="minus"]');
        const plus = this.querySelector('button[name="plus"]');
        if (minus) minus.disabled = min !== null && value <= min;
        if (plus) plus.disabled = max !== null && value >= max;
      }
    }
    customElements.define('quantity-input', QuantityInput);
  }
})();
